import { useGetUser } from 'src/hooks';
import { useCallback, useMemo } from 'react';
import { useUpdateSettingMutation } from 'src/store/services/userSettingsApi';
import { SettingKeys, SettingValue } from 'src/types/settings';
import log from 'src/utils/logger';
import { toast } from 'react-toastify';
import { COMMON_ERROR_TEXT, SAVED_TEXT } from 'src/constants';

interface UpdateSettingArgs {
  value: SettingValue;
  settingKey: SettingKeys;
  hideToast?: boolean;
}

export const useUserSettingsUpdate = () => {
  const { user_id } = useGetUser();

  const [changeSetting, { isLoading: isUpdateIsLoading }] =
    useUpdateSettingMutation({});

  const updateSetting = useCallback(
    async ({ value, settingKey, hideToast }: UpdateSettingArgs) => {
      try {
        if (!!user_id) {
          await changeSetting({
            user_id: user_id,
            setting_key: settingKey,
            body: {
              new_value: value,
            },
          }).unwrap();
          if (!hideToast) {
            toast.success(SAVED_TEXT);
          }
        }
      } catch (error) {
        log.error(error);
        toast.error(COMMON_ERROR_TEXT);
      }
    },
    [changeSetting, user_id],
  );

  return useMemo(
    () => ({
      updateUserSetting: updateSetting,
      isUpdateIsLoading,
    }),
    [updateSetting, isUpdateIsLoading],
  );
};
